import { env } from '@core/env';
import { TokenService } from './token.service';

export class ClassicDIPOService {
  public static generateClassicDipoUrlWithAuth(destination: string, token?: string): string {
    token = token || TokenService.getToken() || '';
    return `${env.classicDipoURL}/login/ssodipo?destinationRedirect=${destination}&token=${token}`;
  }
  public static generateURLHomepage(token?: string): string {
    return this.generateClassicDipoUrlWithAuth('', token);
  }
  public static generateURLForgetPassword(): string {
    return `${env.classicDipoURL}/userProfile/forget`;
  }
  public static generateURLRegister(): string {
    return `${env.classicDipoURL}/userProfile/register`;
  }
  public static generateURLApplication(symbol: string, token?: string): string {
    return this.generateClassicDipoUrlWithAuth(`/application/index?symbol=${symbol}`, token);
  }
  public static generateURLFiling(appId: string | number | null, token?: string): string {
    return this.generateClassicDipoUrlWithAuth(`/filing/edit?appId=${appId || ''}`, token);
  }
}
